import { render, staticRenderFns } from "./SignupFormGroup.vue?vue&type=template&id=3ac44e5c"
import script from "./SignupFormGroup.vue?vue&type=script&lang=js"
export * from "./SignupFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports